<script setup lang="tsx">
import AssetInfo from './AssetInfo.vue'
import AssetHistory from './AssetHistory.vue'
import AssetThreats from './AssetThreats.vue'

const props = defineProps<{ assetId: number }>()
</script>

<template>
	<ul class="nav nav-tabs mb-3" id="assetTabs" role="tablist">
		<li class="nav-item" role="presentation">
			<button class="nav-link active" id="info-tab" data-bs-toggle="tab" data-bs-target="#info" type="button" role="tab">
				{{ $t('asset.info') }}
			</button>
		</li>
		<li v-if="props.assetId > 0" class="nav-item" role="presentation">
			<button class="nav-link" id="risks-tab" data-bs-toggle="tab" data-bs-target="#risks" type="button" role="tab">
				{{ $t('asset.risks.label') }}
			</button>
		</li>
		<li v-if="props.assetId > 0" class="nav-item" role="presentation">
			<button class="nav-link" id="history-tab" data-bs-toggle="tab" data-bs-target="#history" type="button" role="tab">
				{{ $t('asset.history.label') }}
			</button>
		</li>
	</ul>

	<div class="tab-content" id="assetTabsContent">
		<div class="tab-pane fade show active" id="info" role="tabpanel" aria-labelledby="info-tab">
			<AssetInfo :asset-id="props.assetId"></AssetInfo>
		</div>

		<div v-if="props.assetId > 0" class="tab-pane fade" id="risks" role="tabpanel" aria-labelledby="risks-tab">
			<AssetThreats :asset-id="props.assetId"></AssetThreats>
		</div>

		<div v-if="props.assetId > 0" class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
			<AssetHistory :asset-id="props.assetId"></AssetHistory>
		</div>
	</div>
</template>
